export const COMMENTS_ACTIONS = {
    LOADING_VIDEO_COMMENTS: 'LOADING_VIDEO_COMMENTS',
    ADDING_COMMENT: 'ADDING_COMMENT',
    DELETING_COMMENT: 'DELETING_COMMENT',
    DELETED_COMMENT: 'DELETED_COMMENT',
    STORE_COMMENTS: 'STORE_COMMENTS',
    CLEAR_COMMENTS_BY_SCENE_ID: 'CLEAR_COMMENTS_BY_SCENE_ID',
    SAVE_COMMENT_DRAFT: 'SAVE_COMMENT_DRAFT',
    CLEAR_COMMENT_DRAFT: 'CLEAR_COMMENT_DRAFT',
};

export type SceneComment = {
    slide_id: string;
    comment_ids: number[];
    open_comment_ids: number[];
    resolved_comment_ids: number[];
};

export type NumOpenCommentsPerScene = Readonly<Record<string, number>>;

export type CommentUser = {
    external_user_email: string;
    external_user_name: string;
};
